import { Component, OnInit } from '@angular/core';
import { APPCONFIG } from '../../config';
import { Version } from '../../version';

@Component({
  selector: 'my-app-footer',
  styles: [],
  template: require('./footer.component.html')
})

export class AppFooterComponent implements OnInit {
  public AppConfig: any;
  public version: any;

  ngOnInit() {
    this.AppConfig = APPCONFIG;
    this.version = Version;
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/layout/footer/footer.component.ts